// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"3018f68e","866":"43941dfc"}[chunkId] + ".chunk.js";
};